// import Vue from 'vue';
// import Utility from '@/vue/utility/utility';
import BaseModule from '../_base_module';

import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

// initial state
// shape: [{ id, quantity }]
const state = {
  ...BaseModule.state,

  echo: null,
};

// getters
const getters = {
  ...BaseModule.getters,
  isConnected(state, getters, rootState, rootGetters) {
    return state.echo && state.echo.connector.pusher.connection.connection !== null;
  }
};

// actions
const actions = {
  ...BaseModule.actions,
  connect ({state, commit, dispatch, getters, rootState, rootGetters}, payload) {
    if(! rootGetters['current_user/isLoggedIn']) {
      return;
    }

    let echo = new Echo({
      broadcaster: 'pusher',
      key: import.meta.env.PG_PUSHER_APP_KEY,
      cluster: import.meta.env.PG_PUSHER_APP_CLUSTER,
      authEndpoint: rootGetters['api/base_url'] + '/broadcasting/auth',
      auth: {
        headers: {
          "Authorization": 'Bearer ' + rootGetters['current_user/token'],
        }
      },
    });

    dispatch('startListeners', echo);
  },
  startListeners ({state, commit, dispatch, getters, rootState, rootGetters}, echo) {
    echo.private('user.' + rootGetters['current_user/id'])
      .listen('UserUpdated', (event) => {
        console.log('UserUpdated', event);
        commit('current_user/update_state', {property: 'data', value: event}, {root: true});
      });
  }
};

// mutations
const mutations = {
  ...BaseModule.mutations,
  // dummy_mutation (state, id) {
  //     state.id = id;
  // },
};

export default {

  namespaced: true,

  state,
  getters,
  actions,
  mutations
}
